export const approveRequest = (approvalID) => {
    return {
        type: 'APPROVAL_REQUEST',
        approvalId: approvalID
    }
};


export const rejectRequest = (approvalID) => {
    return {
        type: 'REJECT_REQUEST',
        approvalId: approvalID
    }
};

export const setSelectedReason = (selectedReason) => {
    return {
        type: 'SELECTED_REASON',
        value: selectedReason
    }
};